<section class="progress-bar-container">
  <div
    class="progress-bar theme-player__progressBar"
    [ngClass]="{ 'progress-bar--light': isPlayerMobLgView }"
    #progressBar
    (click)="onProgressBarClick($event)"
    (mousedown)="onSeekStart($event)"
    (touchstart)="onSeekStart($event)"
  >
    <span class="loading theme-player__loadingBar" [ngStyle]="{ width: loadProgress + '%' }"></span>
    <span class="song-length theme-player__playedBeatBar" [ngStyle]="{ width: progress + 0.4 + '%' }"></span>
    <span class="current-position-marker theme-player__marker" [ngStyle]="{ left: progress + '%' }">
      @if (showTimesTooltip) {
        <span class="marker-tooltip">
          {{ formattedProgressTooltipTime }}
        </span>
      }
    </span>
  </div>

  @if (showTimesInline) {
    <div class="progress-time">
      <span class="current-time">{{ actualCurrentTime }}</span>
      <span class="total-time">{{ getFormattedTotalTime() }}</span>
    </div>
  }
</section>
